import request from '@/util/request'

// 查询新闻中心列表
export function getNewsList(data){
    return request.post("/system/website/newsCenter/list",data)
}

// 查询新闻详情
export function getNews(data){
    return request.post("/system/website/newsCenter/find",data)
}